import React, { FunctionComponent, useContext, useEffect } from 'react'
import { Layout } from 'antd'
import DevicesList from '../../../DevicesList/DevicesList'
import Collections from '../../../Collections/Collections'
import { useLoaderData, useMatch } from '@tanstack/react-router'
import VehicleLocationHistoryList from '../../../VehicleLocationHistoryList/VehicleLocationHistoryList'
import { MapSettingsContext } from '../../../../contexts/MapSettingsContext'
import MapSettingsContextInterface from '../../../../contexts/MapSettingsContext/MapSettingsContextInterface'
import Geofences from '../../../Geofences/Geofences'
import Directions from '../../../Map/SearchBar/Directions/Directions'

const { Sider } = Layout

interface IProps {
  selectedKey: string | undefined
  setSelectedKey: (key: string) => void
}

const AccessManagerLeftSider: FunctionComponent<any> = (props: IProps) => {
  const { selectedKey, setSelectedKey } = props

  const { selectedVehicleHistory } = useContext(MapSettingsContext) as MapSettingsContextInterface

  const match = useMatch({ strict: false })
  const { assettrakAccess } = useLoaderData({ from: match.routeId ?? '/' })

  useEffect(() => {
    if (selectedVehicleHistory) {
      setSelectedKey('vehicle-history')
    }
  }, [selectedVehicleHistory, setSelectedKey])

  const routes = {
    devices: <DevicesList userId={assettrakAccess.id} />,
    collections: <Collections userId={assettrakAccess.id} />,
    'vehicle-history': <VehicleLocationHistoryList vehicleId={selectedVehicleHistory} />,
    geofences: <Geofences userId={assettrakAccess.id} />,
    directions: <Directions />
  }

  return (
    <Sider collapsed={!selectedKey} collapsedWidth={0} width={400}>
      {selectedKey ? routes[selectedKey] : null}
    </Sider>
  )
}

export default AccessManagerLeftSider
